<template>
<div class="comments">
  <div class="comments__header">
    <span class="comments__title">Comments</span>
    <span class="comments__comments-count">{{commentsCount}}</span>
    <base-material-design-icon @click="$parent.onShowCommentsSection" class="comments__cross" icon="plus"/>
  </div>
  <ul class="comments__list" ref="commentList">
    <div
      v-for="date in getCommentDictDates"
      :key="date"
    >
      <span class="comments__date">{{date | formattedDate}}</span>
      <li class="comments__comment"
        v-for="comment in comments[date]"
        :key="comment.timestamp">
        <Comment :comment="comment"
                 :is-current-user="comment.email === userEmail"
        />
      </li>
    </div>
  </ul>
  <form class="comments__form"
        v-if="!isStaticView"
  >
    <label class="comments__form-input-wrap">
      <textarea class="comments__form-input"
                placeholder="Write your comment"
                v-model="message"
                :disabled="formBlocked"
      ></textarea>
    </label>
    <div @click.prevent="onSendComment" class="comments__send-message-icon">
      <base-material-design-icon
        :icon="'send'"/>
    </div>
    <base-loader class="comments__form-loader"
                  v-if="formBlocked"/>
  </form>
</div>
</template>

<script>
import filters from '@/common/Filters'
import Comment from './Comment'
// eslint-disable-next-line no-unused-vars
import ContentBrief from './index'
import BaseMaterialDesignIcon from "@/common/BaseMaterialDesignIcon";

/**
 * Comments component. Is used in {@link ContentBrief}
 */
export default {
  name: 'Comments',
  props: {
    commentsCount: {
      type: Number,
      required: true
    },
    userEmail: {
      type: String,
      required: true
    },
    comments: {
      type: Object,
      required: true
    },
    isStaticView: {
      type: Boolean,
      default: false
    },
    formBlocked: Boolean
  },
  data () {
    return {
      message: ''
    }
  },
  mounted () {
    this.setScrollToTheBottom()
  },
  updated () {
    this.setScrollToTheBottom()
  },
  components: {
    BaseMaterialDesignIcon,
    Comment
  },
  computed: {
    isEmptyMessage () {
      return this.message.trim() === ''
    },
    getCommentDictDates () {
      return Object.keys(this.comments)
    }
  },
  methods: {
    onSendComment () {
      if (this.isEmptyMessage || this.formBlocked) {
        return
      }
      this.$emit('comment-added', this.message)
      this.message = ''
    },
    setScrollToTheBottom () {
      const scrollHeight = this.$refs.commentList.scrollHeight
      this.$refs.commentList.scrollTop = scrollHeight
    }
  },
  filters: {
    ...filters
  }
}
</script>

<style scoped lang="scss">
  .comments {
    width: 372px;
    margin: 0 auto;

    &__comments-count {
      display: block;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      text-align: center;
      line-height: 24px;
      color: #fff;
      background-color: $rfx-bright-turquoise;
    }

    &__cross {
      font-size: 26px;
      margin-left: auto;
      cursor: pointer;
      transform: rotate(45deg);
    }

    &__send-message-icon {
      color: #284aff;
      position: absolute;
      cursor: pointer;
      right: 25px;
      top: 35px;
      font-size: 28px;
    }

    &__send-message-icon:hover {
      cursor: pointer;
    }

    &__date {
      padding-left: 30px;
    }

    &__header {
      position: absolute;
      top: 0;
      width: -webkit-fill-available;
      padding: 30px 30px 15px 30px;
      display: flex;
      align-items: center;
    }

    &__title {
      font-size: 18px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.56;
      letter-spacing: normal;
      color: #000000;
      margin-right: 10px;
    }

    &__form {
      width: 372px;
      max-height: 90px;
      position: absolute;
      top: calc(100% - 90px);

      &-input-wrap {
        display: flex;
      }

      &-input {
        max-height: 90px;
        overflow-y: scroll;
        box-sizing: border-box;
        margin-bottom: -20px;
        padding: 30px 48px 30px 30px;
        font-size: 14px;
        border: none;
        outline: none;
        flex: 1 1;
        resize: none;
      }

      &-control {
        padding: 20px;
        border-top: 1px solid $rfx-light-grey;
        display: flex;
        justify-content: flex-end;
      }

      &-submit {
        display: block;
        padding: 0;
        color: #fff;
        background-color: $rfx-dark-march;
        border-radius: $rfx-default-border-radius;
        border: none;
        outline: none;
        text-transform: uppercase;
        font-size: 10px;
        font-weight: 500;
        cursor: pointer;
        position: relative;
        top: -63px;
        right: -5px;
        width: 32px;
        height: 32px;

        &:hover {
          background-color: lighten($rfx-medium-march, 5%);
        }

        &:disabled {
          background-color: $rfx-medium-march;
          cursor: default;
        }
      }
    }

    &__form-loader {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, .7);
    }

    &__list {
      list-style-type: none;
      padding: 0;
      position: absolute;
      top: 73px;
      width: 372px;
      overflow-y: scroll;
      left: 0;
      max-height: calc(100% - 163px);
      margin: 0;
    }

    &__comment {
      margin: 30px;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
</style>
